import { PartialStateUpdater, patchState, signalState } from '@ngrx/signals';
import { Signal } from '@angular/core';
import { StateBase } from 'src/app/shared/state/hashmap-state-base';
import {
  TaskDetailsBaseUi,
  TaskGroupBaseUi,
} from '../../models/task-details.model';

export interface StateManager extends StateBase {
  taskDetails: Signal<TaskDetailsBaseUi | null>;
  taskGroup: Signal<TaskGroupBaseUi | null>;
  loading: Signal<boolean>;
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  error: Signal<any>;
  setTaskDetails: (taskDetails: TaskDetailsBaseUi | null) => void;
  setTaskGroup: (taskGroup: TaskGroupBaseUi | null) => void;
  setLoading: (loading: boolean) => void;
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  setError: (error: any) => void;
}

export function taskDetailsStateFactory(): StateManager {
  return new TaskDetailsBaseState();
}

interface State {
  taskDetails: TaskDetailsBaseUi | null;
  taskGroup: TaskGroupBaseUi | null;
  loading: boolean;
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  error: any;
}

const defaultState: State = {
  taskDetails: null,
  taskGroup: null,
  loading: false,
  error: null,
};

class TaskDetailsBaseState implements StateManager {
  private readonly taskDetailsState = signalState<State>(defaultState);

  public readonly taskDetails = this.taskDetailsState.taskDetails;
  public readonly taskGroup = this.taskDetailsState.taskGroup;
  public readonly loading = this.taskDetailsState.loading;
  public readonly error = this.taskDetailsState.error;
  private _lastModified: number = -1;

  public get lastModified(): number {
    return this._lastModified;
  }

  setTaskGroup(taskGroup: TaskGroupBaseUi | null): void {
    this._lastModified = Date.now();
    patchState(this.taskDetailsState, this.taskGroupSetter(taskGroup));
  }

  setTaskDetails(taskDetails: TaskDetailsBaseUi | null): void {
    this._lastModified = Date.now();
    patchState(this.taskDetailsState, this.taskDetailsSetter(taskDetails));
  }

  setLoading(loading: boolean): void {
    patchState(this.taskDetailsState, this.loadingSetter(loading));
  }

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  setError(error: any): void {
    patchState(this.taskDetailsState, this.errorSetter(error));
  }

  private taskDetailsSetter(
    taskDetails: TaskDetailsBaseUi | null
  ): PartialStateUpdater<{ taskDetails: State['taskDetails'] }> {
    return () => {
      return {
        taskDetails,
      };
    };
  }

  private taskGroupSetter(
    taskGroup: TaskGroupBaseUi | null
  ): PartialStateUpdater<{ taskGroup: State['taskGroup'] }> {
    return () => {
      return {
        taskGroup,
      };
    };
  }

  private loadingSetter(
    loading: boolean
  ): PartialStateUpdater<{ loading: boolean }> {
    return () => ({ loading });
  }

  private errorSetter(error: boolean): PartialStateUpdater<{ error: boolean }> {
    return () => ({ error });
  }
}
